import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1
  },
  sectionTitle: {
    marginTop: 30,
    paddingBottom: 5,
    position: 'relative',
    width: 'fit-content',
    '&:before': {
      content: "''",
      position: 'absolute',
      bottom: 0,
      left: 0,
      height: 2,
      width: '100%',
      backgroundColor: theme.palette.grey[400]
    },
    '&:after': {
      content: "''",
      position: 'absolute',
      bottom: 0,
      left: 0,
      height: 2,
      width: '30%',
      backgroundColor: theme.palette.primary.main
    }
  },
  marginBottom: {
    marginBottom: 20
  },
  deleteIcon: {
    fontSize: 42,
    marginTop: 24,
    marginBottom: 16
    // Deliberately no zIndex. This icon is a flex item, so a z-index applies to it
    // even without `position` -- and 10000 beat the fixed AppBar's 1201 (theme.zIndex.drawer
    // + 1), with no stacking context in between (`content` sets no z-index, transform or
    // opacity). Scrolling a rate plan form therefore carried the bin up OVER the header,
    // on top of the shopping-cart icon. Painting in DOM order is what we want: the fixed
    // header should cover page content, not the other way round.
  }
}))
export default useStyles
